import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios, { AxiosResponse } from 'axios'
import { CrudState } from '../../interfaces/CrudState'
import { Prefix, PrefixType } from '../../interfaces/Prefix'
import { getMemsourceJobs } from '../../../httpClient/Requests/Api/MEMSOURCE/job'

export const initialState: CrudState = {
    items: [],
    loading: false,
    error: null,
}

export const fetchJobs = (prefix: PrefixType, cancelToken?: any, setCancelToken?: any) =>
    createAsyncThunk(
        `${prefix}/jobs/fetchJobs`,
        async ({ filterBy }: { filterBy: any; executionCondition?: boolean }, { signal }) => {
            if (typeof cancelToken !== 'undefined') {
                cancelToken.cancel('Operation canceled due to new request.')
            }
            const source = axios.CancelToken.source()
            setCancelToken(source)
            signal.addEventListener('abort', () => {
                source.cancel()
            })
            let response: AxiosResponse<Record<string, any>[]>
            switch (prefix) {
                case Prefix.MEMSOURCE: {
                    response = await getMemsourceJobs(filterBy, source.token)
                    setCancelToken(undefined)
                    return response.data
                }
                default:
                    return null
            }
        },
        {
            condition: ({ executionCondition }) => {
                if (!executionCondition) {
                    // Already fetched or in progress, don't need to re-fetch
                    return false
                }
            },
        },
    )

const jobsSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/jobs`,
        initialState,
        reducers: {
            resetJobs: () => initialState,
        },
        extraReducers: (builder) => {
            // fetchJobs:
            builder.addCase(fetchJobs(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchJobs(prefix).fulfilled, (state, action) => ({
                ...state,
                items: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchJobs(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

export const jobsActions = (prefix: PrefixType) => jobsSlice(prefix).actions

const jobs = (prefix: PrefixType) => jobsSlice(prefix).reducer

export default jobs
